import { Navigate } from 'react-router-dom';
import SecureStorage from 'react-secure-storage';

const ProtectedRoute = ({ children }) => {
  const isLoggedIn = SecureStorage.getItem('isLoggedIn') === 'true';

  if (!isLoggedIn) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;

